import React from "react";
import { useProfile, getTimezoneAbbr } from "@moonscape/shared";
import { Lab } from "@/components/ms";

export const TradeItemSmall = ({ t, isAuditRow = false, auditReason = "", isQueryLoading }) => {
  return (
    <div className="flex min-h-[44px] cursor-pointer flex-col border-b border-ms-line transition-colors hover:bg-ms-card2">
      <div className="flex flex-1 items-center justify-between gap-3">
        <TradeItemLeftComponent t={t} />
        <TradeItemRightComponent t={t} />
      </div>
      {isAuditRow && (
        <div className="px-4 pb-2 text-[11px] text-ms-mute">
          Audit reason: {auditReason}
        </div>
      )}
    </div>
  );
};

export const TradeItemLeftComponent = ({ t }) => {
  const asset = t.getAsset();
  const formattedType = t.formattedType();
  const exchangeName = t.getExchangeName();
  const { profile } = useProfile();
  const taxTimezone = profile?.taxTimezone ?? null;
  const formattedTimestamp = t.formattedTimestamp(taxTimezone);

  return (
    <div className="min-w-0 flex-1 truncate px-4 py-2.5">
      <p className="truncate text-[13.5px] tracking-[-0.01em] text-ms-ink">
        {asset && formattedType && `${asset} (${formattedType})`}
      </p>
      {t.txn_note && (
        <p className="truncate text-[10px] text-ms-dim" title={t.txn_note}>
          {t.txn_note}
        </p>
      )}
      <Lab size={9} className="mt-[3px] block text-ms-dim">
        {[exchangeName, formattedTimestamp].filter(Boolean).join(" · ")}
        {taxTimezone && ` ${getTimezoneAbbr(taxTimezone)}`}
      </Lab>
    </div>
  );
};

export const TradeItemRightComponent = ({ t }) => {
  const isInterestType = t.isInterestType();
  const isTransferType = t.isTransferType();
  const isTradeType = t.isTradeType();
  const formattedBuyAmountWithCurrency = t.formattedBuyAmountWithCurrency();
  const formattedSellAmountWithCurrency = t.formattedSellAmountWithCurrency();
  const formattedAmountWithCurrency = t.getFormattedAmountWithCurrency();
  const type = t.type;

  return (
    <div className="flex-none truncate px-4 py-2.5 text-right font-mono tabular-nums">
      {isInterestType && (
        <p className="text-[13.5px] font-medium text-ms-ink">
          {formattedBuyAmountWithCurrency}
        </p>
      )}

      {isTransferType && (
        <p className="text-[13.5px] font-medium text-ms-ink">
          {type === "deposit" && formattedAmountWithCurrency}
          {type === "withdrawal" && formattedAmountWithCurrency}
        </p>
      )}

      {isTradeType && (
        <>
          <p className="text-[13.5px] font-medium text-ms-ink">
            {formattedBuyAmountWithCurrency}
          </p>
          <p className="text-[11px] text-ms-dim">{formattedSellAmountWithCurrency}</p>
        </>
      )}
    </div>
  );
};
